
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/home-staging/boulder",
      function () {
        return require("private-next-pages/home-staging/boulder/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/home-staging/boulder"])
      });
    }
  